import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { CoreHelperService } from '../core-helper/core-helper.service';
import { CommonNotificationService } from 'src/app/common/service/common-notification.service';
import { Router } from '@angular/router';

@Injectable()

export class InterceptorService implements HttpInterceptor {

  count = 0;
  excludedApiUrls: string[] = [
    '/api/Notification/GetNotificationCountByUserId',
    '/api/Notification/MarkNotificationDisplayed',
    '/api/Notification/GetNotificationByUserId',
    '/api/VOBService/GetVobDashboardCounts',
    '/api/user/GetUserStatusDetailById',
    '/api/Common/GetDataForDropdownList',
    '/api/Common/GetUserListByDepartmentId',
    '/api/StatusMaster/GetStatusList',
    '/api/VOBService/GetVobMails',
    '/api/SharePoint/SyncSharepointSiteId',
    '/api/BillingRequest/billing-tab-count',
    '/api/BillingRequest/get-billing-requests',
    '/api/BillingRequest/get-facility-master',
    '/api/BillingRequest/get-carrier-master',
    '/api/BillingRequest/get-loc-master',
    '/api/BillingRequest/get-billing-user-master',
    '/api/CereusReports/caseslist',
  ];

  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private _coreHelper: CoreHelperService,
    private _commonNotificationService: CommonNotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinner.hide('global');
    if (!(request.url.includes('ExecutiveDashboard')) && !(this.excludedApiUrls.some(url => request.url.includes(url)))) {
      this.spinner.show('global')
    }
    this.count++;
    return next.handle(request)
      .pipe(tap(
        (event: any) => {
          if (request instanceof HttpErrorResponse) {
            if (request.status !== 401) {
              return;
            }
            this.router.navigate(['/login']);
          }
          if (!this._coreHelper.isNullOrUndefined(event) && !this._coreHelper.isNullOrUndefined(event.body)) {
            if (!event?.body?.apiStatus) {
              if (!this._coreHelper.isNullOrUndefined(event?.body?.apiMessage)) {
                if (!request.context.get(byPassErrorMessage)) {
                  var res = event?.body?.apiMessage?.trim().toLowerCase().replace(/\s/g, "");
                  if (!res.toLowerCase().includes('nodatafound!')) {
                    if (res.toLowerCase().includes('accessdenied')) {
                      this._commonNotificationService.displayError('403 - Permission Denied.');
                    } else {
                      this._commonNotificationService.displayError('Application error found.');
                    }
                  }
                }
              }
            }
          }
          setTimeout(() => {
            this.dropdownAction();
          }, 1000)
        }
      ), finalize(() => {
        this.count--;
        if (this.count == 0) {
          this.spinner.hide('global')
        }
      })
      );
  }

  dropdownAction = () => {
    var actionCollection = document.getElementsByClassName("dropdown-actions-fixed")
    var arrayActionCollection = Array.from(actionCollection);
    this._coreHelper.dropDownPositionUpdate(arrayActionCollection);
  }
}

export const byPassErrorMessage = new HttpContextToken(() => false);
